import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

export default function ColorCircle({ colorName, colorFill, onPress, }) {
    return <TouchableOpacity
        onPress={() => onPress(colorName)}
        style={[styles.colorView, {
            backgroundColor: colorFill,
            borderWidth: colorName == "BRANCO" ? 1 : 0
        }]}>
        <Text style={{
            color: colorName == "BRANCO" ? "black" : "white",
            fontWeight: "500",
        }}>{colorName}</Text>
    </TouchableOpacity>

}

const styles = StyleSheet.create({
    colorView: {
        width: "100%",
        borderRadius: 8,
        padding: 4,
        textAlign: "center",
        marginBottom: 8,
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
})